export default __webpack_public_path__ + "locales/pt/PeopleTranslations.json?hash=4b7ffed47dc2ba8bf7577d56d22b8092";